import Vue from 'vue'
import VueRouter from 'vue-router'
import History from '@/utils/History.js'
import appHelper from '@/utils/AppHelper'
import moment from 'moment'

Vue.use(VueRouter)

const ImportViewCommon = file => () => import('../views/Biz/Common/' + file)
const ImportViewDevice = file => () => import('../views/Biz/Device/' + file)
const ImportViewNotify = file => () => import('../views/Biz/Notify/' + file)
const ImportViewUser = file => () => import('../views/Biz/User/' + file)

const routes = [
  {
    path: '/',
    name: '首页',
    component: () => import('../views/Home/Index.vue'),
    meta: { keepAlive: true, hasFooterNav: true }
  },
  {
    path: '/Home',
    name: '首页',
    component: () => import('../views/Home/Index.vue'),
    meta: { keepAlive: true, hasFooterNav: true }
  },
  {
    path: '/Default',
    name: '测试页面1',
    component: () => import('../views/Default.vue')
  },
  {
    path: '/AuthorizationSuccess',
    name: '授权成功',
    component: () => import('../views/AuthorizationSuccess.vue')
  },
  {
    path: '/about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  { path: '/ActionResult', component: ImportViewCommon('ActionResult'), name: '操作结果' },
  {
    path: '/DeviceList',
    component: ImportViewDevice('DeviceList'),
    name: '摄像机列表',
    meta: { keepAlive: true, TempKeep: true, hasFooterNav: true }
  },
  {
    path: '/DeviceNotifyList',
    component: ImportViewNotify('DeviceNotifyList'),
    name: '历史记录',
    meta: { keepAlive: true, TempKeep: true, hasFooterNav: true }
  },
  {
    path: '/DeviceNotifyListV2',
    component: ImportViewNotify('DeviceNotifyListV2'),
    name: '历史记录2',
    meta: { keepAlive: true, TempKeep: true }
  },
  {
    path: '/JoinHhUser',
    component: ImportViewUser('JoinHhUser'),
    name: '邀请加入'
  },
  {
    path: '/UserInvite',
    component: ImportViewUser('UserInvite'),
    name: '邀请新用户'
  },
  { path: '/NotifyDetail', component: ImportViewNotify('NotifyDetail'), name: '抓拍详情' },
  { path: '/DistanceNotifyDetail', component: ImportViewNotify('DistanceNotifyDetail'), name: '抓拍详情(区间测速)' },
  { path: '/DeviceNotifyStat', component: ImportViewNotify('DeviceNotifyStat'), name: '历史统计' }
]

//  base: process.env.BASE_URL,
const router = new VueRouter({
  mode: 'history',
  isBack: false,
  refresh: false,
  routes
})

/**
 * 添加了一个返回函数，用来判断页面跳转的时候用哪种动画
 */
router.goBack = (val, refresh) => {
  // if (!History.canBack()) {
  //   console.log('这个时候要退出公众号')
  // }
  router.isBack = true
  router.refresh = refresh
  if (val === 200) {
    window.history.go(-1)
    return
  }
  if (window.history.length <= 2) {
    router.replace({ path: '/' })
  } else {
    if (!val) {
      val = -1
    }
    window.history.go(val)
    // router.go(-1)
  }
}

router.goPage = (obj) => {
  var page = obj
  if (typeof obj !== 'object') {
    page = {
      path: obj
    }
  }
  if (!page.query) {
    page.query = {}
  }
  page.query.r = Math.round(Math.random() * 1000 + 1000)
  page.query.t = moment().format('YYYYMMDDTHHmmss');
  router.isBack = false
  router.push(page)
}

router.goBackV2 = () => {
  var prevPath = History.getPrevFullPath()
  if (prevPath === '') {
    router.goPage({ path: '/Home' })
    return
  }
  var pindex = prevPath.indexOf('?')
  if (pindex !== -1) {
    prevPath = prevPath.substring(0, pindex);
  }
  router.goPage({ path: prevPath })
}

router.goActionResPage = (query) => {
  router.goPage({ path: '/ActionResult', query: query })
}

router.afterEach((to, from) => {
  if (router.isBack) {
    History.pop()
  } else {
    if (to.path !== 'AuthorizationSuccess' && to.path !== 'Default') {
      History.push(to.fullPath)
    }
  }
  const href = `//${location.host + to.fullPath}`
  appHelper.getWxConfig(href)
  appHelper.submitBrowseHist(to)
})

router.beforeEach(async(to, from, next) => {

  if (!appHelper.clearLocalData && !appHelper.debug) {
    // appHelper.setUserInfo({ openid: '' })
    appHelper.clearLocalData = true
  }
  // console.log('fullPath=', to.fullPath);
  // console.log('openid=', to.query.openid);

  if (to.query.openid) {
    await appHelper.pullUserInfo(to.query.openid)
    await appHelper.pullNewUserToken()
    await appHelper.pullUserCustomData()
  }

  var userInfo = appHelper.getUserInfo()

  // console.log(location.host + '.userInfo', userInfo);

  if (userInfo.openid === '') {
    // 防止无限循环
    if (to.path === '/AuthorizationSuccess' || to.path === '/Default') {
      next()
      return
    }
    var newQuery = to.query
    newQuery.call_url = to.path
    next({ path: '/Default', query: newQuery })

  } else {
    // if (to.name === 'AuthorizationSuccess' || to.name === 'Default') {
    //   console.log('回到首页....', from.path);
    //   next({ path: '/' })
    //   return
    // }
    if (!appHelper.authed) {
      var vas = await appHelper.pullNewUserToken();
      if (!vas) {
        appHelper.setUserInfo({ openid: '' })
        var newQuery2 = to.query
        newQuery2.call_url = to.path
        next({ path: '/Default', query: newQuery2 })
        return
      }
    }

    var histList = History.goList();
    History.curPath = to.fullPath
    // console.log('History.curPath', History.curPath);
    // console.log('History', histList);
    var prevPage = histList[histList.length - 2];
    // console.log('prevPage', prevPage);
    // console.log('prevPage2', to.fullPath);
    from.meta.TempKeep = false
    if ((prevPage === to.fullPath && prevPage) || to.meta.keepAlive || to.meta.TempKeep) {
      to.meta.TempKeep = true
    } else {
      to.meta.TempKeep = false
    }
    // console.log('to' + to.path, to.meta.TempKeep);
    next()
  }

})

export default router
